// extracted by mini-css-extract-plugin
export var container = "Team-module--container--DxEze";
export var profile = "Team-module--profile--MjhqY";
export var img = "Team-module--img--T7+k3";
export var flexContainer = "Team-module--flexContainer--ohiAw";
export var txtContainer = "Team-module--txtContainer--L9dSN";